<!-- TODO CHECK OR CREATE NEW PERMISSIONS FOR INCIDENT COMMUNICATIONS -->
@if (permissionService.can_read_service_config$ | async ) {
<div class="body">
  @if (intermediateCommunicationForm) {
  <form [formGroup]="intermediateCommunicationForm">
    <div class="form-group">
      <span class="field-label">ServiceNow Ticket ID <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <input nxInput id="serviceNowTicket" formControlName="serviceNowTicket" placeholder="e.g., INC1234567" />
      </nx-formfield>
      @if (intermediateCommunicationForm.get('serviceNowTicket')?.invalid && intermediateCommunicationForm.get('serviceNowTicket')?.value) {
        <div class="error-message">
          @if (intermediateCommunicationForm.get('serviceNowTicket')?.hasError('required')) {
            ServiceNow Ticket is required
          } @else if (intermediateCommunicationForm.get('serviceNowTicket')?.hasError('invalidServiceNowTicket')) {
            ServiceNow Ticket must start with "INC" followed by numbers (e.g., INC8045599)
          }
        </div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Jira Ticket Key</span>
      <nx-formfield appearance="outline">
        <input nxInput id="jiraTicketKey" formControlName="jiraTicketKey" placeholder="e.g., AZTGSA-12345" />
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">PagerDuty Incident ID <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <input nxInput id="pagerDutyIncidentId" formControlName="pagerDutyIncidentId" />
      </nx-formfield>
      @if (intermediateCommunicationForm.get('pagerDutyIncidentId')?.invalid &&
      intermediateCommunicationForm.get('pagerDutyIncidentId')?.touched) {
      <div class="error-message">PagerDuty Incident ID is required</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Priority <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <select nxInput id="priority" formControlName="priority">
          <option value="" disabled>Select a priority</option>
          @for (option of priorityOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </nx-formfield>
      @if (intermediateCommunicationForm.get('priority')?.invalid &&
      intermediateCommunicationForm.get('priority')?.touched) {
      <div class="error-message">Please select a priority</div>
      }
    </div>

    <div class="form-group">
      <label class="field-label" for="incidentEnvironmentCode">Incident Environment <span class="required">*</span></label>
      <nx-formfield appearance="outline">
        <select nxInput id="incidentEnvironmentCode" formControlName="incidentEnvironmentCode">
          <option value="" disabled>Select the environment of the incident</option>
          @for (option of incidentEnvironmentOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
          }
        </select>
      </nx-formfield>
      @if (intermediateCommunicationForm.get('incidentEnvironmentCode')?.invalid &&
      intermediateCommunicationForm.get('incidentEnvironmentCode')?.touched) {
      <div class="error-message">Please select the environment of the incident</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Service <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <nx-dropdown
                     [showFilter]="true"
                     [filterPlaceholder]="'Search for a service'"
                     formControlName="service">
          <nx-dropdown-item
                            *ngFor="let service of serviceOptions"
                            [value]="service.id">{{ service.name }}</nx-dropdown-item>
        </nx-dropdown>
      </nx-formfield>
      @if (intermediateCommunicationForm.get('service')?.invalid &&
      intermediateCommunicationForm.get('service')?.touched) {
      <div class="error-message">Service is required</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Application <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <select nxInput id="application" formControlName="application" [disabled]="applicationOptions.length === 0">
          <option value="" disabled>{{ applicationOptions.length === 0 ? 'No applications available' : 'Select an
            application' }}</option>
          @for (application of applicationOptions; track application.id) {
          <option [value]="application.id">{{ application.name }}</option>
          }
        </select>
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Features</span>
      <nx-formfield appearance="outline">
        <nx-multi-select
                         [filter]="true"
                         [filterPlaceholder]="'Search for a feature'"
                         formControlName="features"
                         [options]="featureOptions"
                         selectLabel="name"
                         selectValue="id"
                         [disabled]="featureOptions.length === 0">
        </nx-multi-select>
      </nx-formfield>
    </div>

    @if (selectedFeatures.length === 0 || selectedFeatures.length === 1) {
      <div class="form-group">
        <span class="field-label">To <span class="required">*</span></span>
        <nx-formfield appearance="outline">
          <input nxInput id="to" formControlName="to" placeholder="Enter email addresses separated by commas" />
        </nx-formfield>
        @if (intermediateCommunicationForm.get('to')?.invalid && intermediateCommunicationForm.get('to')?.touched) {
        <div class="error-message">Please enter valid email addresses separated by commas</div>
        }
      </div>
    } @else {
      @for (feature of selectedFeatures; track feature.id) {
        <div class="form-group">
          <span class="field-label">To: <span class="to-name">{{ feature.name }}</span> <span class="required"> *</span></span>
          <nx-formfield appearance="outline">
            <input nxInput [id]="'to-' + feature.id" [formControlName]="'to_' + feature.id" placeholder="Enter email addresses separated by commas" />
          </nx-formfield>
          @if (intermediateCommunicationForm.get('to_' + feature.id)?.invalid && intermediateCommunicationForm.get('to_' + feature.id)?.touched) {
          <div class="error-message">Please enter valid email addresses separated by commas</div>
          }
        </div>
      }
    }

    <div class="form-group">
      <span class="field-label">CC</span>
      <nx-formfield appearance="outline">
        <input nxInput id="cc" formControlName="cc" placeholder="Enter email addresses separated by commas" />
      </nx-formfield>
      @if (intermediateCommunicationForm.get('cc')?.invalid && intermediateCommunicationForm.get('cc')?.touched) {
      <div class="error-message">Please enter valid email addresses separated by commas</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Communication Counter <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <input nxInput id="communicationCounter" type="number" formControlName="communicationCounter" min="1" />
      </nx-formfield>
      @if (intermediateCommunicationForm.get('communicationCounter')?.invalid &&
      intermediateCommunicationForm.get('communicationCounter')?.touched) {
      <div class="error-message">Communication Counter must be at least 1</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Subject</span>
      <nx-formfield appearance="outline">
        <input nxInput id="subject" formControlName="subject" />
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Description <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <textarea nxInput id="description" formControlName="description" rows="4"></textarea>
      </nx-formfield>
      @if (intermediateCommunicationForm.get('description')?.invalid &&
      intermediateCommunicationForm.get('description')?.touched) {
      <div class="error-message">Description is required</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Impacted Users</span>
      <nx-formfield appearance="outline">
        <textarea nxInput id="impactedUsers" formControlName="impactedUsers" rows="3"></textarea>
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Root Cause</span>
      <nx-formfield appearance="outline">
        <textarea nxInput id="rootCause" formControlName="rootCause" rows="3"></textarea>
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Start Date <span class="required">*</span></span>
      <nx-formfield appearance="outline">
        <input nxInput id="startDate" formControlName="startDate" placeholder="DD/MM/YYYY at HH.mm am/pm, Paris time" />
      </nx-formfield>
      @if (intermediateCommunicationForm.get('startDate')?.invalid &&
      intermediateCommunicationForm.get('startDate')?.touched) {
      <div class="error-message">Start Date is required</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Estimated End (Paris time) @if (isResolved) {<span class="required">*</span>}</span>
      <div class="datetime-picker-inputs">
        <nx-formfield appearance="outline" class="date-field">
          <input [min]="minDate" nxInput nxDatefield [datepicker]="datepicker" formControlName="estimatedEndDate" placeholder="Select date" parseFormat="dd/MM/yyyy" displayFormat="dd/MM/yyyy" (keydown)="onDateKeydown($event)">
          <nx-datepicker-toggle nxFormfieldSuffix [for]="datepicker"></nx-datepicker-toggle>
          <nx-datepicker #datepicker></nx-datepicker>
        </nx-formfield>
        <div class="time-field">
          <nx-timefield appearance="outline" formControlName="estimatedEndTime"></nx-timefield>
        </div>
      </div>
      @if (intermediateCommunicationForm.get('estimatedEndDate')?.value && !intermediateCommunicationForm.get('estimatedEndTime')?.value) {
      <div class="error-message">Time is required when a date is selected</div>
      }
      @if (!intermediateCommunicationForm.get('estimatedEndDate')?.value && intermediateCommunicationForm.get('estimatedEndTime')?.value) {
      <div class="error-message">Date is required when a time is selected</div>
      }
      @if (intermediateCommunicationForm.get('estimatedEndTime')?.hasError('invalidTime') && intermediateCommunicationForm.get('estimatedEndTime')?.touched) {
      <div class="error-message">Please enter a valid time (HH:mm format, hours 00-23, minutes 00-59)</div>
      }
      @if (intermediateCommunicationForm.get('estimatedEndDate')?.hasError('minDate') && intermediateCommunicationForm.get('estimatedEndDate')?.touched) {
      <div class="error-message">Estimated end date cannot be before today</div>
      }
    </div>

    <div class="form-group">
      <span class="field-label">Next Communication</span>
      <nx-formfield appearance="outline">
        <input nxInput id="nextCommunication" formControlName="nextCommunication"
               placeholder="In 2 hours after first communication..." />
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Ongoing Actions</span>
      <nx-formfield appearance="outline">
        <textarea nxInput id="ongoingActions" formControlName="ongoingActions" rows="4"
                  placeholder="• List actions here – Done&#10;• List another action – In Progress"></textarea>
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Workaround</span>
      <nx-formfield appearance="outline">
        <textarea nxInput id="workaround" formControlName="workaround" rows="3"></textarea>
      </nx-formfield>
    </div>

    <div class="form-group">
      <span class="field-label">Technical Information</span>
      <nx-formfield appearance="outline">
        <textarea nxInput id="technicalInformation" formControlName="technicalInformation" rows="4"></textarea>
      </nx-formfield>
    </div>
    @if (incidentLastUpdateDateTime) {
    <div class="last-update-card">
      <span class="last-update-label">🕐 Last Updated:</span>
      <span class="last-update-value">{{ incidentLastUpdateDateTime | date: 'medium' }}</span>
      @if (incidentLastUpdatedby) {
      <span class="last-update-by">by <strong>{{ incidentLastUpdatedby }}</strong></span>
      }
    </div>
    }

    <div class="button-container">
      <button nxButton="primary" type="button" [disabled]="!intermediateCommunicationForm.valid || isSubmitting"
              (click)="onSubmit()">
        {{ isSubmitting ? 'Sending...' : 'Send Communication' }}
      </button>

    </div>

  </form>
  }
</div>
<!-- TODO CHECK OR CREATE NEW PERMISSIONS FOR INCIDENT COMMUNICATIONS -->
} @else if ((permissionService.can_read_service_config$ | async) === false) {
<nx-message context="error">
  <span class="nx-font-weight-bold">Error</span><br />
  You don't have access to this application. Please contact your administrator.
</nx-message>
}